import React from 'react';

import type { Props, VacancyCalendarRef } from './';
import VacancyCalendar from './';

const VacancyCalendarWithRef = React.memo(
  React.forwardRef((props: Props, ref: React.Ref<VacancyCalendarRef>) => (
    <VacancyCalendar {...props} innerRef={ref} />
  )),
);

export default VacancyCalendarWithRef;
